import 'virtual:uno.css'

// 引入epic-designer样式
import 'epic-designer/dist/style.css'
import ElementPlus from 'element-plus'

// epic-designer
import { setupElementPlus } from 'epic-designer/dist/ui/elementPlus'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import stores from './stores'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import * as Sentry from '@sentry/vue'

import './assets/css/main.css'
import { registerBaiduAnalytics } from '@/common/utils/analytics'
import { getSentryEnvironment } from '@/common/utils/common.ts'

// epic-designer 使用Antd UI
setupElementPlus()
// 注册扩展组件
// setupDesignerExtensions()

const app = createApp(App)
if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        sendDefaultPii: true,
        environment: getSentryEnvironment(),
        release: __APP_INFO__.fullVersion,
    })
}
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router)
    // Enable baidu analytics
    .use(registerBaiduAnalytics, {
        // If you provide a router instance,
        // You can get the ability to automatically track pageviews
        router,
        websiteIds: [import.meta.env.VITE_BAIDU_ANALYTICS_ID],
        debug: false,
    })
    .use(stores)

app.use(ElementPlus)
app.mount('#app')

// 配置全局 icons
// app.config.globalProperties.$icons = Icons
// // Antd 注入全部图标（这样注入之后，就可以全局直接使用 icon 组件，不需要每个页面去引入了）
// Object.keys(Icons).forEach((key: string) => {
//     app.component(key, Icons[key as keyof typeof Icons])
// })

app.config.errorHandler = (err, instance, info) => {
    // 向追踪服务报告错误
    if (import.meta.env.VITE_ENABLE_SENTRY === 'true') {
        Sentry.captureException(err, {
            contexts: { vue: { component: instance, info } },
        })
    }
}
